import React from 'react';
import { Input, Select } from '@avila-tek/ui/src';

export interface DniInputProps {
  label: string;
  className?: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeSelect: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  children: React.ReactChild | React.ReactChild[];
  selectName: string;
  placeholder: string;
  defaultSelect: string;
  inputValue: string;
  selectValue: string;
  inputName: string;
  reducerId?: string;
  disabled?: boolean;
  minLength?: number;
  maxLength?: number;
}

export default function DniInput({
  label,
  className = '',
  handleChange,
  handleChangeSelect,
  children,
  inputName,
  selectName,
  placeholder,
  defaultSelect,
  inputValue,
  selectValue,
  disabled = false,
  reducerId = '',
  ...props
}: DniInputProps) {
  return (
    <div className="w-full ">
      <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
        {label}
      </span>
      <div className="flex flex-row w-full">
        <div className="w-16">
          <Select
            className={`rounded-r-none rounded  ${className}`}
            onChange={handleChangeSelect}
            label=""
            name={selectName}
            value={selectValue}
            data-id={reducerId}
            disabled={disabled}
            required
          >
            {children}
          </Select>
        </div>
        <div className="w-full">
          <Input
            label=""
            type="text"
            name={inputName}
            className={`rounded-l-none border-l-0 w-full ${className}`}
            onChange={handleChange}
            placeholder={placeholder}
            value={inputValue}
            data-id={reducerId}
            disabled={disabled}
            step={1}
            minLength={7}
            maxLength={10}
            required
          />
        </div>
      </div>
    </div>
  );
}
